<h1 *ngIf="!isEditMode">Add New Currencies</h1>
<h1 *ngIf="isEditMode">Editing Currencies {{ id }}</h1>

<dynamic-form key="currencies" [id]="id" [editMode]="isEditMode" [showFileUploader]="true" [fileUploaderUrl]="'https://worker.flora-cms.bgamestudios.com/upload'" (onUpload)="onUploadCompleted($event)"></dynamic-form>
